import { render, staticRenderFns } from "./bankPoint.vue?vue&type=template&id=6b31f1fb&scoped=true&"
import script from "./bankPoint.vue?vue&type=script&lang=js&"
export * from "./bankPoint.vue?vue&type=script&lang=js&"
import style0 from "./bankPoint.vue?vue&type=style&index=0&id=6b31f1fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31f1fb",
  null
  
)

export default component.exports